import { MessageCircle } from 'react-feather';
import { useState, useEffect } from 'react';
import { authAPI } from '../api';
import { useAuth } from '../context/AuthContext';

export default function WhatsAppButton() {
  const { user, loading } = useAuth();
  const [num, setNum] = useState((process.env.REACT_APP_WHATSAPP || '+237688656076').replace(/\s/g, ''));

  useEffect(() => {
    if (loading || !user) {
      return;
    }

    authAPI.publicSettings().then(r => {
      const whatsappNum = (r.data.settings?.whatsapp_number || process.env.REACT_APP_WHATSAPP || '+237688656076').replace(/\s/g, '');
      setNum(whatsappNum);
    }).catch(() => {
      setNum((process.env.REACT_APP_WHATSAPP || '+237688656076').replace(/\s/g, ''));
    });
  }, [loading, user]);

  if (loading || !user) {
    return null;
  }

  return (
    <a
      href={`https://wa.me/${num}?text=Hello%20NiceBooster%20Support%2C%20I%20need%20help%20with%20my%20order.`}
      target="_blank"
      rel="noreferrer"
      title="Chat with support on WhatsApp"
      style={{
        position: 'fixed', bottom: 28, right: 28,
        width: 56, height: 56, borderRadius: '50%',
        background: 'linear-gradient(135deg, #25D366, #128C7E)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 26, boxShadow: '0 4px 24px rgba(37,211,102,0.45)',
        textDecoration: 'none', zIndex: 999,
        transition: 'transform 0.2s, box-shadow 0.2s',
        animation: 'waPulse 2.5s infinite',
        color: 'white'
      }}
      onMouseOver={e => { e.currentTarget.style.transform = 'scale(1.12)'; e.currentTarget.style.boxShadow = '0 6px 32px rgba(37,211,102,0.65)'; }}
      onMouseOut={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(37,211,102,0.45)'; }}
    >
      <MessageCircle size={24} />
      <style>{`
        @keyframes waPulse {
          0%,100%{ box-shadow:0 4px 24px rgba(37,211,102,0.45); }
          50%{ box-shadow:0 4px 36px rgba(37,211,102,0.75); }
        }
      `}</style>
    </a>
  );
}
